import { injectable } from 'inversify';

import { HttpService } from '../http';

@injectable()
export class FilesService {
  constructor(private http: HttpService) {}

  /** Скачать файл
   * @param {string} url Адрес ресурса
   * @param {boolean} [withAuth] Флаг авторизации
   * @returns {Promise<{file: Promise<Blob>, filename: string}>}
   * */
  async getFile(url: string, withAuth?: boolean) {
    const result = await this.http.getFile(url, {
      withSide: true,
      withAuth: withAuth,
    });

    return result;
  }
}
